<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 12h16"
      stroke="currentColor"
    stroke-linecap="round"
    stroke-width="2"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
